import React, { useEffect } from 'react';
import toastError from "../../errors/toastError";

import Typography from "@material-ui/core/Typography";
import LocationOnIcon from "@material-ui/icons/LocationOn";

import { Button, Divider, } from "@material-ui/core";

const LocationPreview = ({ image, link, description }) => {
    useEffect(() => {}, [image, link, description]);

    let normalizedImage = image || "";
    let normalizedLink = link || "";
    let normalizedDescription = description || "";

    // Older Whaileys messages stored only "map-link|description".
    if (/^https?:\/\//i.test(normalizedImage) && !/^https?:\/\//i.test(normalizedLink)) {
        normalizedDescription = normalizedLink;
        normalizedLink = normalizedImage;
        normalizedImage = "";
    }

    // WhatsApp can return an empty base64 thumbnail for sent locations.
    if (/^data:image\/[^;]+;base64,$/i.test(normalizedImage)) {
        normalizedImage = "";
    }

    // Some returned messages put the map URL in the description field.
    if (/^https?:\/\//i.test(normalizedDescription)) {
        const coordinateMatch = normalizedLink.match(/[?&]q=([^&]+)/i);
        normalizedDescription = coordinateMatch
            ? decodeURIComponent(coordinateMatch[1]).replace(",", ", ")
            : "Ubicación compartida";
    }

    const handleLocation = async() => {
        try {
            window.open(normalizedLink);
        } catch (err) {
            toastError(err);
        }
    }

    return (
		<>
			<div style={{
				minWidth: "250px",
			}}>
				<div>
					{normalizedImage ? (
						<div style={{ float: "left" }}>
							<img src={normalizedImage} alt="location" onClick={handleLocation} style={{ width: "100px", cursor: "pointer" }} />
						</div>
					) : (
						<div style={{ float: "left", width: "100px", height: "80px", display: "flex", alignItems: "center", justifyContent: "center" }}>
							<LocationOnIcon color="primary" style={{ fontSize: 42 }} />
						</div>
					)}
					{ normalizedDescription && (
					<div style={{ display: "flex", flexWrap: "wrap" }}>
						<Typography style={{ marginTop: "12px", marginLeft: "15px", marginRight: "15px", float: "left" }} variant="subtitle1" color="primary" gutterBottom>
							<div style={{ whiteSpace: "pre-line" }}>{normalizedDescription}</div>
						</Typography>
					</div>
					)}
					<div style={{ display: "block", content: "", clear: "both" }}></div>
					<div>
						<Divider />
						<Button
							fullWidth
							color="primary"
							onClick={handleLocation}
							disabled={!normalizedLink}
						>Visualizar</Button>
					</div>
				</div>
			</div>
		</>
	);

};

export default LocationPreview;
